export default function() {
  controller('popup-check', self => {
    
    self.closest('.js-popup-check').find('.js-popup-checkbox').on('click', function() {
        
      var itemIndex = $(this).closest('.js-popup-check').index();
            
      if ($(this).closest('.js-popup-check').find('input').prop('checked')) {
        
        $('.js-popup-spinner').eq(itemIndex).addClass('show');
        
      } else {
        
        $('.js-popup-spinner').eq(itemIndex).removeClass('show');
        
      }
      
    });

  });
}
